export const useBannerBackgroundColor = () => {
    return [
        'rgb(99, 102, 241)', // Indigo
        'rgb(243, 244, 246)', // Gray
        'rgb(41, 37, 36)', // Stone
        'rgb(245, 158, 11)', // Amber
        'linear-gradient(to right, rgb(59, 130, 246), rgb(37, 99, 235))',
        'linear-gradient(to right, rgb(59, 130, 246), rgb(147, 51, 234))',
        'linear-gradient(to right, rgb(244, 63, 94), rgb(248, 113, 113), rgb(239, 68, 68))',
        'linear-gradient(to left bottom, rgb(49, 46, 129), rgb(129, 140, 248), rgb(49, 46, 129))',
        'radial-gradient(at right center, rgb(186, 230, 253), rgb(129, 140, 248))',
        'linear-gradient(to right, rgb(255, 228, 230), rgb(204, 251, 241))',
    ]
}

export const useSolidColor = [
    'rgb(147, 51, 234)', // Purple
    'rgb(239, 68, 68)', // Orange
    'rgb(41, 37, 36)', // Stone
    'rgb(255, 255, 255)', // White
    'rgb(245, 158, 11)', // Amber
    'rgb(20, 184, 166)',  // Teal
    'rgb(51, 65, 85)',  // Slate700
    'rgb(132, 204, 22)',  // Lime
    'rgb(14, 165, 233)',  // Blue
    'rgb(226, 232, 240)',  // Slate200
    'rgb(79, 70, 229)',  // Indigo
    'rgb(219, 39, 119)',  // Pink
]

export const useHeadlineText = () => {
    return [
        'Hello World!',
        'The Industry Standard.',
        'Catalogue Dynamics Overview.',
        'A Business Simulation.',
        'Economic Trends.',
        'Corporate Review.',
        'Industry Analysis.',
        'Case Study.',
        'Catalogue Trends Review.',
    ]
}

// 0-1: Main Layout (bg & text color)
// 2-3: Navigation and box (bg & text color)
// 4-5: Button and mini-box (bg & text color)
export const useColorTheme = [
    ['#4f46e5', '#f3f4f6', '#362cdb', '#fde047', '#4f46e5', '#f3f4f6', '#fcd34d', '#374151'],  // Deep Sea Serenity 
    ['#4f46e5', '#f3f4f6', '#362cdb', '#fde047', '#4f46e5', '#f3f4f6', '#fcd34d', '#374151'],  // Deep Sea Serenity 
    ['#f43f5e', '#F5F5F5', '#E3B7C8', '#000000', '#D6C7E2', '#000000', '#fca5a5', '#374151'],  // Rosewater Blush 
    ['#000000', '#f2f2f2', '#424242', '#fde047', '#8e44ad', '#ffffff', '#fcd34d', '#374151'],  // Amoled
    ['#0F1626', '#FFFFFF', '#1e293b', '#f1f5f9', '#0f172a', '#e2e8f0', '#0F1626', '#374151'],  // Black and White (Retina)
]